import React, { FunctionComponent } from 'react';
import { Grid, Card, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  '@global .ui.card, .ui.cards > .card': {
    boxShadow:
      '0 .0625rem 0 0 rgba(0,0,0,0.03), 0 .125rem .375rem 0 rgba(0,0,0,0.06); !important',
  },
  card: {
    width: '19.75em !important',
    margin: '2em !important',
  },
  gridRow: {
    margin: '0 !important',
    padding: '1rem 0 !important',
  },
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const render2ColRow = (classes: Styles) => (
  <Card.Content extra>
    <Grid>
      <Grid.Row className={classes.gridRow}>
        <Grid.Column width={6}>
          <Placeholder>
            <Placeholder.Line length="full" />
          </Placeholder>
        </Grid.Column>
        <Grid.Column width={10}>
          <Placeholder>
            <Placeholder.Line length="full" />
          </Placeholder>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Card.Content>
);

const renderIconRow = (classes: Styles) => (
  <Card.Content extra>
    <Grid>
      <Grid.Row className={classes.gridRow}>
        <Grid.Column width={16}>
          <Placeholder>
            <Placeholder.Header image>
              <Placeholder.Line length="full" />
            </Placeholder.Header>
          </Placeholder>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Card.Content>
);

const MerchantCardPlaceholder: FunctionComponent<Props> = ({ classes }) => (
  <Card className={classes.card}>
    <Card.Header>
      <Placeholder>
        <Placeholder.Header>
          <Placeholder.Image />
        </Placeholder.Header>
      </Placeholder>
    </Card.Header>
    {render2ColRow(classes)}
    {render2ColRow(classes)}
    {render2ColRow(classes)}
    {renderIconRow(classes)}
    {renderIconRow(classes)}
    {renderIconRow(classes)}
    <Card.Content extra>
      <Grid>
        <Grid.Row className={classes.gridRow}>
          <Grid.Column width={16}>
            <Placeholder>
              <Placeholder.Line />
            </Placeholder>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
);

export default withStyles(styles)(MerchantCardPlaceholder);
